import React from 'react'

const GhOpenSource = () => {
  return (
    <div className='gh-opensource'>
      Implementation for fetching open source contributions of user is in development phase.
    </div>
  )
}

export default GhOpenSource